module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5334/images/default-avatar.png"